import { Tab } from "@headlessui/react";
import React from "react";
import PrimaryButton from "ui/buttons/PrimaryButton";

export default function StepModal({ TabData, SelectedTab, SetSelectedTab }) {
  // Find the tab after selectedTab
  let nextTab = TabData.find((tab) => tab.index === SelectedTab.index + 1);
  return <div></div>;
}
